import React from 'react';

const Contact = () => {
  return (
    <section className="flex flex-col md:flex-row md:items-center md:justify-start md:gap-6 mt-20">
  <div className="space-y-2 md:mr-4">
    <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
      Get in Touch
    </h2>
    <p className="text-gray-400">I'm currently available for freelance work.</p>
  </div>
  <a
    href="mailto:megumi.h.mizuno@gmail.com" data-cta="contact"
    className="mt-4 md:mt-0 bg-gradient-to-r from-cyan-400 to-blue-500 text-white font-semibold px-8 py-4 rounded-xl hover:from-cyan-500 hover:to-blue-600 transition-colors duration-300 shadow-lg shadow-blue-500/20 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
  >
    Contact me
  </a>
</section>
  );
};

export default Contact;
